import type { Ref } from 'vue';
import { useState, useNuxtApp } from 'nuxt/app';
import type { UserProfile } from '~/models/user/type';
import { fetchCurrentUserProfile } from '~/models/user/api';

type UserState = {
  profile: UserProfile,
  isAfterRegistration: boolean
}

export const useUser = () => {
  const state: Ref<UserState> = useState('UserState', () => {
    return {
      profile: {
        userId: 0,
        lastName: '',
        firstName: '',
        icon: {
          name: '',
          url: ''
        },
        cover: {
          name: '',
          url: ''
        },
        passwordRegistered: true,
        settings: {
          // defaultは非公開状態
          atteluCareerStatus: 3
        }
      } as UserProfile,
      isAfterRegistration: false
    };
  });

  const setProfile = (profile: UserProfile) => {
    const { state } = useUser();
    state.value.profile = profile;
  };

  return {
    state: state,
    profile: state.value.profile,
    setProfile: setProfile,
    setIsAfterRegistration: (state: Ref<UserState>, isAfterRegistration: boolean) => {
      state.value.isAfterRegistration = isAfterRegistration;
    },
    fetchCurrentUserProfile: async (): Promise<void> => {
      const { state } = useUser();
      const { $userServiceAxios } = useNuxtApp();
      const params = {} as any;

      // ユーザー情報登録直後の場合は登録完了のコンバージョン(CV)の確認メール送信するためのパラメータに追加。
      if (state.value.isAfterRegistration) {
        params.isAfterRegistration = state.value.isAfterRegistration;
      }

      const profile: UserProfile = await fetchCurrentUserProfile(
        $userServiceAxios,
        params
      );
      setProfile(profile);
      state.value.isAfterRegistration = false;
    },
    updateIsAfterRegistration: (isAfterRegistration: boolean): void => {
      const { state } = useUser();
      state.value.isAfterRegistration = isAfterRegistration;
    }
  };
};
